import React from 'react';
import './Styles.css';
import { Ui24Delete } from '@ids/react-icons';
import { employerModalType } from '../EmployerModalType';
import { formatMessage } from '../../../Localization/formatMessage';
import Messages from '../../../Localization/Messages';
import { useNavigate } from 'react-router-dom';

const ConnectedAgents = ({ agents, setOpenedModal, setModalAgent }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="employerPage-tableTitle">{formatMessage(Messages.employerPage_agentTableTitle)}</div>
      <div className="employerPage-tableContainer-row common-table-row headerRow">
        <div>{formatMessage(Messages.common_agentCode)}</div>
        <div>{formatMessage(Messages.common_costCenter)}</div>
        <div>{formatMessage(Messages.common_externalSalesCode)}</div>
        <div>{formatMessage(Messages.common_name)}</div>
        <div>{formatMessage(Messages.common_additionalName)}</div>
        <div></div>
      </div>
      {agents?.map((agent, index) => (
        <div
          className={`employerPage-tableContainer-row common-table-row ${
            index % 2 === 1 ? 'common-table-evenRow' : ''
          }`}
          key={index}>
          <div
            className="clickable employerPage-tableContainer-agentCode"
            onClick={() => {
              navigate(`/team/view/${agent.codePrefix}`);
            }}>
            {agent.agentCode}
          </div>
          <div>{agent.costCenter}</div>
          <div>{agent.externalSalesCode}</div>
          <div>{agent.name}</div>
          <div>{agent.additionalName}</div>
          <div>
            <Ui24Delete
              className="clickable"
              onClick={() => {
                setOpenedModal(employerModalType.RemoveAgent);
                setModalAgent(agent);
              }}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default ConnectedAgents;
